import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-link-to",
  "use": "icon-link-to-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 16\" id=\"icon-link-to\"><circle cx=\"6\" cy=\"10\" r=\"5.5\" stroke=\"#F7A600\" /><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"4\" height=\"6\" x=\"4\" y=\"7\" viewBox=\"0 0 4 6\"><path stroke=\"#F7A600\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1 5 2.5-2L1 1\" /></svg></symbol>"
});
var result = sprite.add(symbol);
export default symbol